import { Component } from "@angular/core";
import { MatList, MatListItem } from "@angular/material/list";
import { RouterLink, RouterLinkActive } from "@angular/router";

@Component({
    selector: "app-side-nav",
    templateUrl: "./side-nav.component.html",
    styleUrls: ["./side-nav.component.scss"],
    imports: [MatList, MatListItem, RouterLink, RouterLinkActive]
})
export class SideNavComponent {
  constructor() {}
}
